import { render, staticRenderFns } from "./moonDATA.vue?vue&type=template&id=4035958a&scoped=true&"
import script from "./moonDATA.vue?vue&type=script&lang=js&"
export * from "./moonDATA.vue?vue&type=script&lang=js&"
import style0 from "./moonDATA.vue?vue&type=style&index=0&id=4035958a&lang=scss&scoped=true&"
import style1 from "./moonDATA.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035958a",
  null
  
)

export default component.exports